import Pusher, { Options } from 'pusher-js';
export class PusherFacade {
  static create(app_key: string, options?: Options): Pusher  {
    return new Pusher(app_key, options);
  }
}
